<template>
  <div class="py-10 md:py-20 px-4 md:px-0 bg-semantic-surface-container-low">
    <!-- eslint-disable vue/no-v-html -->
    <div class="max-w-wrapper-lg mx-auto">
      <p
        v-if="title"
        ref="title"
        class="text-2xl/[120%] text-center md:text-4xl/[120%] mb-2 md:mb-4 text-semantic-surface-on-surface font-bold"
        v-html="title"
      />
      <p
        v-if="description"
        ref="description"
        class="text-base/[150%] text-center md:text-lg/[150%] mb-2 md:mb-4 text-semantic-surface-on-surface"
        v-html="description"
      />

      <div
        v-if="getPostsData.length"
        class="drop-shadow-sm-2 flex flex-grow md:flex-row md:overflow-hidden overflow-auto md:py-0 py-2 md:gap-8 gap-4 md:mt-10 mt-6 items-stretch"
      >
        <V2MoleculesCardArticleCard
          v-for="(item, itemKey) in getPostsData"
          :key="itemKey"
          :image-path="item.image"
          :title="item.title"
          :author-name="item.author"
          :cta-btn-to="item.url"
          wrapper-class="md:!min-w-[22rem] !min-w-[21rem] mb-1"
          inner-wrapper-class="md:h-[18rem] h-[16rem]"
          cta-btn-label="Read more"
        />
      </div>

      <div class="flex justify-end md:mt-10 mt-6">
        <V2AtomsButton has-icon-right to="/health-insurance/guides">
          View all articles
        </V2AtomsButton>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2OrganismHomeArticleSection'
})

defineProps({
  title: {
    type: String,
    default: ''
  },

  description: {
    type: String,
    default: ''
  },

  list: {
    type: Array,
    default: () => []
  }
})

const postsStore = usePostsStore()
const { GET_POSTS } = storeToRefs(postsStore)
await postsStore.initialize()

const getPostsData = computed(() => {
  return GET_POSTS.value.slice(0, 3)
})
</script>
